<div class="d-flex partners">
    <div class="partner-item" *ngFor="let partner of partners">
        <img  [style.width]="partner.width || '80px'" [src]="'/assets/icons/'+partner.icon" alt="img">
    </div>
</div>